import React from "react";
import moment from "moment";
import { CartesianGrid, Legend, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";

import { useTheme } from "../../../../hooks/theme";
import CartaoGrafico, { CORES } from "./CartaoGrafico";
import useResumoDespacho from "./useResumoDespacho";

// Etiquetas emitidas e lotes despachados por dia (PO1-3494): linha do tempo do
// período (`porDia`, um ponto por dia com movimento).

const fmtDia = (dia) => (dia ? moment(dia, "YYYY-MM-DD").format("DD/MM") : "");

export default function ChartDespachoPorDia({ deferLoad = false, onRegisterFetch }) {
  const { darkMode } = useTheme();
  const { dados, carregando, erro } = useResumoDespacho({ deferLoad, onRegisterFetch });
  const cor = darkMode ? "#e9ecef" : "#1e1e2f";
  const linhas = dados ? dados.porDia.map((d) => ({ ...d, rotulo: fmtDia(d.dia) })) : [];

  return (
    <CartaoGrafico titulo="Despacho por dia" subtitulo="Etiquetas emitidas e lotes despachados, dia a dia, no período" carregando={carregando} erro={erro} vazio={!linhas.length}>
      <ResponsiveContainer width="100%" height={250}>
        <LineChart data={linhas} margin={{ top: 10, right: 20, left: 0, bottom: 10 }}>
          <CartesianGrid stroke="rgba(29,140,248, 0.1)" strokeWidth={1} />
          <XAxis dataKey="rotulo" stroke={cor} style={{ fontWeight: 100 }} />
          <YAxis stroke={cor} style={{ fontWeight: 100 }} allowDecimals={false} />
          <Tooltip contentStyle={{ background: darkMode ? "#1e1e2f" : "#fff", border: "none" }} />
          <Legend layout="horizontal" verticalAlign="bottom" align="center" />
          <Line type="monotone" name="Etiquetas emitidas" dataKey="etiquetasEmitidas" stroke={CORES.emitidas} strokeWidth={2} dot={{ r: 2 }} />
          <Line type="monotone" name="Lotes despachados" dataKey="lotesDespachados" stroke={CORES.lotes} strokeWidth={2} dot={{ r: 2 }} />
        </LineChart>
      </ResponsiveContainer>
    </CartaoGrafico>
  );
}
